var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tag--container"},[_c('div',{staticClass:"tag--base",class:_vm.resolveTypeStyle},[_vm._t("content",[_vm._v(_vm._s(_vm.label))])],2)])}
var staticRenderFns = []

export { render, staticRenderFns }